/*
* config base
*
* */
let node_custom_env = process.env.NODE_CUSTOM_ENV
if (node_custom_env !== 'production' && node_custom_env !== 'staging') {
  node_custom_env = 'development'
}
let node_user_api = '' // 用户后端接口
let node_order_api = '' // 订单后端接口
let node_user_openId = '' // 判断openId是否存在后端接口
let Appid = ''  // 微信appid

if (node_custom_env === 'production') { // 正式环境
  node_user_api = 'https://entry-api.qiyudc.com/managerbankh5/usercenter'
  node_order_api = 'https://order-web.qiyudc.com/managerbankh5/order'
  node_user_openId = 'https://api.qiyudc.cn/wechat'
  Appid = 'wxaa6e26c9d85c5b43'  // 旗鱼点餐商家服务中心

}
else if (node_custom_env === 'staging') { // 测试环境
  node_user_api = 'http://usercenter-web.qiyubi.cn/managerbankh5/usercenter'
  node_order_api = 'http://test-order-web.qiyubi.cn/managerbankh5/order'
  node_user_openId = 'http://test-api.qiyubi.cn/wechat'
  Appid = 'wx3a03badd8b04e027'  // 鱼你旗行
}
else { // 开发环境
  node_user_api = 'http://usercenter-web.qiyubi.cn/managerbankh5/usercenter'
  node_order_api = 'http://test-order-web.qiyubi.cn/managerbankh5/order'
  node_user_openId = 'http://test-api.qiyubi.cn/wechat'
  Appid = 'wx3a03badd8b04e027'  // 鱼你旗行
}


var common = (function() {
  return {
    url_user: node_user_api,
    url_order: node_order_api,
    url_openId: node_user_openId,
    Appid: Appid,

    clearCash: function() {
      if (common.localGet('cash') == null || common.localGet('cash') === '') {
        common.localSet('cash', { 'cash': 'first' })
        window.location.reload()
      } else { // alert('clearCash');
        common.localRemove('cash')
      }
    },
    getUrlParam: function(name) { // 获取url指定参数
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')// 构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg)// 匹配目标参数
      if (r != null) return unescape(r[2])
      return null// 返回参数值
    },
    localSet: function(name, data) {
      common.localRemove(name)
      sessionStorage.setItem(name, JSON.stringify(data))
    },
    localRemove: function(name) {
      sessionStorage.removeItem(name)
    },
    localGet: function(name) {
      return JSON.parse(sessionStorage.getItem(name))
    },
    formatDate: function(secs) {
      var t = new Date(secs)
      var year = t.getFullYear()
      var month = t.getMonth() + 1
      if (month < 10) { month = '0' + month }
      var date = t.getDate()
      if (date < 10) { date = '0' + date }
      var hour = t.getHours()
      if (hour < 10) { hour = '0' + hour }
      var minute = t.getMinutes()
      if (minute < 10) { minute = '0' + minute }
      var second = t.getSeconds()
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + date
    },
    formatDate2: function(secs) {
      var t = new Date(secs)
      var year = t.getFullYear()
      var month = t.getMonth() + 1
      if (month < 10) { month = '0' + month }
      var date = t.getDate()
      if (date < 10) { date = '0' + date }
      var hour = t.getHours()
      if (hour < 10) { hour = '0' + hour }
      var minute = t.getMinutes()
      if (minute < 10) { minute = '0' + minute }
      var second = t.getSeconds()
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    },
    removeByValue(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === val) {
          arr.splice(i, 1)
          break
        }
      }
    }
  }
})()

export default common



// WEBPACK FOOTER //
// ./src/common/js/common.js